import { useViewerQuery } from "queries/viewerQuery";
import React, { useEffect } from "react";
import { graphql } from "babel-plugin-relay/macro";
import { useSetFlag } from "queries/users/setFlag";
import { useMutation } from "react-relay";
import { logPurchase } from "tools/analyticEvents";
import { SubscriptionPurchaseEventMutation } from "./__generated__/SubscriptionPurchaseEventMutation.graphql";
import { useSeeHint } from "components/hint/Hint";
import { TUTORIALDONE_SHARED_HINT } from "sharedJs__generated/constants";

export const updateTrialSubscriptionQL = graphql`
  mutation SubscriptionPurchaseEventMutation($transactionId: String!) {
    updateTrialSubscription(transactionId: $transactionId) {
      subscriptions {
        transactionId
        czk
      }
    }
  }
`;

const SubscriptionPurchaseEvent: React.FC<{}> = () => {
  const { viewer, getFlag, hintWasSeen } = useViewerQuery();
  const setFlag = useSetFlag();
  const done = React.useRef(false);
  const [updateTrialSubscription] = useMutation<SubscriptionPurchaseEventMutation>(updateTrialSubscriptionQL);
  const seeHint = useSeeHint();
  useEffect(() => {
    const statusFlag = getFlag("myTrialEventStatus");
    if (!statusFlag) return;

    const enoughTime = Date.now() - 15 * 60 * 1000; // 15 minutes
    const tooLate = Date.now() - 6 * 24 * 60 * 60 * 1000; // 6 days
    if (
      viewer?.subscription &&
      statusFlag.updated < enoughTime &&
      statusFlag.updated > tooLate &&
      statusFlag.body?.sent === false &&
      statusFlag.body?.transactionId === viewer.subscription.transactionId &&
      hintWasSeen(TUTORIALDONE_SHARED_HINT) &&
      !done.current
    ) {
      updateTrialSubscription({
        variables: { transactionId: viewer.subscription.transactionId },
        onCompleted: (response) => {
          setFlag({ name: "myTrialEventStatus", body: { sent: true } });
          const subscription = response?.updateTrialSubscription?.subscriptions?.find(
            (s) => s.transactionId === viewer.subscription.transactionId
          );
          if (subscription?.czk) {
            logPurchase({ price: subscription.czk, currency: "CZK" });
            seeHint("active_trial");
          }
        }
      });
      done.current = true;
    }
  }, [viewer, getFlag, setFlag, updateTrialSubscription, seeHint, hintWasSeen]);

  return null;
};

export default SubscriptionPurchaseEvent;
